import { render, staticRenderFns } from "./Perubahan.vue?vue&type=template&id=d7daa44e&"
import script from "./Perubahan.vue?vue&type=script&lang=js&"
export * from "./Perubahan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports